export const redirect = (location) => {
  window.location = location;
};

export const getLocation = () => window.location;
